<template>
    <div class="master-form-ticket">
        <validation-observer ref="refComponent" tag="form">
            <v-row>
              <v-col cols="6" class="pt-0 pb-0">
                  <v-autocomplete
                    v-model="moduleId"
                    :items="listModule"
                    item-text="name"
                    item-value="id"
                    label="Module"
                    class="ma-0 pa-0"
                    attach
                    :aLight="'right'"
                  >
                    <template  v-slot:label>
                      Module <span style="color: red;margin-left: 2px;">*</span>
                    </template>
                  </v-autocomplete>
              </v-col>
                <v-col cols="6" class="pt-0 pb-0">
                <validation-provider v-slot="{ errors }"  name="Nhóm ticket" rules="required">
                    <v-autocomplete
                        v-model="groupTicketName"
                        :items="listTicketGroup"
                        item-text="groupTicketName"
                        item-value="groupTicketName"
                        label="Chọn nhóm ticket"
                        class="ma-0 pa-0"
                        :error-messages="errors"
                        attach
                        clearable
                        no-data-text="Không có dữ liệu"
                        :aLight="'right'"
                        @change="changeTicketGroup"
                    >
                      <template  v-slot:label>
                        Chọn nhóm ticket <span style="color: red;margin-left: 2px;">*</span>
                      </template>
                    </v-autocomplete>
                </validation-provider>
                </v-col>
                <v-col cols="12" class="pt-0 pb-0" v-if="checkTicketType(groupTicketName) ">
                <validation-provider v-slot="{ errors }"  name="Loại ticket" :rules="checkTicketType(groupTicketName)  ? 'required' : ''">
                    <v-autocomplete
                        v-model="typeTicketName"
                        :items="listTicketType"
                        item-text="typeTicketName"
                        item-value="typeTicketName"
                        attach
                        :aLight="'right'"
                        clearable
                        no-data-text="Không có dữ liệu"
                        class="ma-0 pa-0"
                        label="Chọn loại ticket"
                        :error-messages="errors"
                        @change="changeTicketType"
                    >
                      <template  v-slot:label>
                        Chọn loại ticket <span style="color: red;margin-left: 2px;">*</span>
                      </template>
                    </v-autocomplete>
                </validation-provider>
                </v-col>
                <template v-for="(component, index) in templateFields">
                    <v-col :cols="component.col ? component.col : 12" class="pt-0 pb-0" :key="index">
                        <base-text
                                v-if="component.dataType === typeComponent.text && component.isShow == 1"
                                v-model="dataComponent[component.name]"
                                :rule-form-ref="$refs.refComponent"
                                :label="component.label"
                                :name-ref="component.name"
                                :event-model="component.event"
                                :required="component.required || component.name !== 'otherAddress'"
                                :clearable="!component.readonly"
                                :readonly="component.readonly"
                                @searchInput="searchInput"
                        />
                        <base-select
                                v-if="component.dataType === typeComponent.select && component.isShow == 1"
                                :label="component.label"
                                :name-ref="component.name"
                                :rule-form-ref="$refs.refComponent"
                                v-model="dataComponent[component.name]"
                                :value="dataComponent[component.name]"
                                :options="component.dataMapField"
                                :required="component.required || checkRequired(component.name)"
                                :event-model="component.event"
                                :clearable="!component.readonly"
                                :readonly="component.readonly"
                                @onChangeData="searchInput"
                        />
                      <template v-if="component.dataType === typeComponent.file && component.isShow == 1">
                        <div class="d-flex align-center" style="column-gap: 10px;"   v-for="(file, indexFile) in dataComponent[component.name]"  :key="indexFile+'file'">
                          <div style="width: calc(100% - 50px)">
                            <base-file
                              :label="component.label"
                              :name-ref="component.name"
                              :rule-form-ref="$refs.refComponent"
                              v-model="file.name"
                              :value="file.name"
                              :required="component.required"
                              :event-model="component.event"
                            />
                          </div>
                          <div style="width: 40px; justify-content: center" class="d-flex align-center">
                            <v-btn @click="handleDeleteFile(file)"
                                   color="primary"
                                   small
                                   icon
                                   style="background: #F4F5FA !important;">
                              <v-icon>mdi-delete-outline</v-icon>
                            </v-btn>
                          </div>
                        </div>
                        <v-btn @click="handleAddFile()"
                               text
                               small
                               style="background: #F4F5FA !important; color: blue !important"
                               v-if="dataComponent[component.name].length < 5"
                        > <v-icon>mdi-plus</v-icon> Thêm file
                        </v-btn>
                      </template>
                        <base-textarea
                          v-if="component.dataType === typeComponent.textarea && component.isShow == 1"
                          v-model="dataComponent[component.name]"
                          :rule-form-ref="$refs.refComponent"
                          :label="component.label"
                          :name-ref="component.name"
                          :event-model="component.event"
                          :required="component.required"
                          :clearable="!component.readonly"
                          :readonly="component.readonly"
                          @searchInput="searchInput"
                        />
                    </v-col>
                </template>
                <v-col cols="12" class="pt-3 pb-3">
                    <div class="d-flex align-center justify-center">
                       <v-btn v-if="checkAuthorization('care-submit-ticket_create')" color="#E91E63" style="color: white !important;" class=" mx-2" @click="handleCreate()">Gửi hỗ trợ</v-btn>
                   </div>
                </v-col>
            </v-row>
        </validation-observer>
    <v-dialog v-if="dialogConfirmSupport" content-class="dialog-waiting" class="text-center py-5 px-5" v-model="dialogConfirmSupport" width="450">
        <template>
            <v-card style="background-color: #fff; padding: 20px;">
                <svg
                    class="float-left ml-2" width="68" height="68" viewBox="0 0 68 68" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M37.4 23.8H30.6V17H37.4M37.4 51H30.6V30.6H37.4M34 0C29.5351 0 25.1138 0.879436 20.9888 2.5881C16.8637 4.29676 13.1156 6.80118 9.95837 9.95837C3.58213 16.3346 0 24.9826 0 34C0 43.0174 3.58213 51.6654 9.95837 58.0416C13.1156 61.1988 16.8637 63.7033 20.9888 65.4119C25.1138 67.1206 29.5351 68 34 68C43.0174 68 51.6654 64.4179 58.0416 58.0416C64.4179 51.6654 68 43.0174 68 34C68 29.5351 67.1206 25.1138 65.4119 20.9888C63.7033 16.8637 61.1988 13.1156 58.0416 9.95837C54.8844 6.80118 51.1363 4.29676 47.0112 2.5881C42.8862 0.879436 38.4649 0 34 0Z"
                        fill="#0088FF"/>
                </svg>
                <div style="width: calc(100% - 110px) !important;    max-width: none !important;" class="text-2 float-right ml-2">
                    <p>Mã khách hàng: {{ dataComponent.customerCode }}</p>
                    <p  v-if="groupTicketName" class="ma-0">Nhóm: {{ groupTicketName }}</p>
                    <p v-if="typeTicketName" class="">Loại: {{ typeTicketName}}</p>
                    <p>Nhấn xác nhận thông tin để tạo hỗ trợ.</p>
                    <div class="group-btn">
                        <v-btn color="#E91E63" style="color: white !important;" class=" ma-0 mr-2" @click="createForm"
                        >Xác nhận</v-btn
                        >
                        <v-btn
                            color="btn-cancel"
                            class="ma-0 ml-3"
                            @click="dialogConfirmSupport = false"
                        >Hủy</v-btn>
                    </div>
                </div>
            </v-card>
        </template>
    </v-dialog>
    </div>
</template>
<script>
import TokenService from '@/helpers/token';
import BaseFile from '@/modules/teacher-support/components/base-file.vue';
import BaseText from '@/modules/teacher-support/components/base-text.vue';
import BaseSelect from '@/modules/teacher-support/components/base-select.vue';
import RepositoryFactory from '@/services/RepositoryFactory';
import Repository from '@/services/Repository';
import BaseTextarea from '@/modules/teacher-support/components/base-textarea.vue';
import { v1 as uuidv1 } from 'uuid';

const TicketRepository = RepositoryFactory.get('ticket');
const apiCrm = process.env.VUE_APP_API_ERP;
const dataConstForm = {
  customerCode: '',
  studentName: '',
  studentId: '',
  homeRoomTeacherName: '',
  classCode: '',
  teacherName: '',
  teacherCode: '',
  careTakerName: '',
  description: '',
  fileAttachment: [
    { id: uuidv1(), name: '' },
  ],
  recipientName: '',
  receiverAddress: '',
  otherAddress: '',
  nameCodeLeader: '',
  departmentOfTheTicketCreator: '',
  subjectName: '',
  gradeName: '',
  level: '',
};
export default {
  name: 'MasterForm',
  components: {
    BaseTextarea, BaseFile, BaseSelect, BaseText,
  },
  data() {
    return {
      typeComponent: {
        text: 'text',
        select: 'select',
        textarea: 'textarea',
        file: 'file',
      },
      dataComponent: {},
      groupTicketName: '',
      typeTicketName: '',
      listTicketGroup: [],
      listTicketGroupClone: [],
      templateFields: [],
      moduleId: '',
      templateId: '',
      dialogConfirmSupport: false,
      listSystemModule: [],
      listModule: [],
    };
  },
  async created() {
    this.dataComponent = _.cloneDeep(dataConstForm);
    await this.getListTicketGroup();
    await this.getListSystemModule();
    if (this.$route.query && this.$route.query.module) {
      const { module } = this.$route.query;
      let moduleName = '';
      if (module === 'Blended') {
        moduleName = 'Tutor';
      } else {
        moduleName = module;
      }
      const moduleID = this.listModule.find((item) => item.name.toUpperCase() === moduleName.toUpperCase());
      this.moduleId = moduleID.id;
    }
  },
  watch: {
    moduleId(value) {
      if (value) {
        this.getListTicketGroup();
        this.templateFields = [];
        this.dataComponent = _.cloneDeep(dataConstForm);
        this.groupTicketName = '';
        this.typeTicketName = '';
        this.listTicketGroup = _.cloneDeep(this.listTicketGroupClone);
      }
    },
  },
  computed: {
    listTicketType() {
      if (this.listTicketGroup.length) {
        return this.listTicketGroup.filter((item) => (item.typeTicketName !== '' || item.typeTicketName != null) && item.groupTicketName === this.groupTicketName);
      }
      return [];
    },
  },
  methods: {
    checkRequired(componentName) {
      const listNoRequired = [
        'gradeName',
        'otherAddress',
      ];
      if (componentName) {
        return !listNoRequired.includes(componentName);
      }
      return true;
    },
    handleDeleteFile(file) {
      const index = this.dataComponent.fileAttachment.findIndex((item) => item.id === file.id);
      this.dataComponent.fileAttachment.splice(index, 1);
    },
    handleAddFile() {
      this.dataComponent.fileAttachment.push({ id: uuidv1(), name: '' });
    },
    async getListSystemModule() {
      try {
        const response = await TicketRepository.getListSystemModuleApi();
        if (response.success) {
          this.listSystemModule = response.data;
          if (this.listSystemModule.length) {
            const findModule = this.listSystemModule.find((item) => item.id === 3);
            this.listModule = findModule && findModule.module ? findModule.module : [];
          } else {
            this.listModule = [];
          }
        } else {
          this.listSystemModule = [];
        }
      } catch (e) {
        console.log(e);
      }
    },
    async checkDataType() {
      const listQuery = _.cloneDeep(this.$route.query);
      delete listQuery.typeCurriculum;
      const dataClone = _.cloneDeep(this.dataComponent);
      const loader = this.$loading.show();
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const item of this.templateFields) {
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const key in listQuery) {
          dataClone[key] = (key === 'studentId' || key === 'classCode') && this.$route.query[key] ? Number(this.$route.query[key]) : this.$route.query[key];
          // eslint-disable-next-line no-restricted-syntax
          if (item.name === key) {
            if (item.linkApi !== null) {
              // eslint-disable-next-line no-await-in-loop
              await this.updateDataMapField(item, dataClone);
            }
            // item.readonly = true;
            this.dataComponent[item.name] = (key === 'studentId' || key === 'classCode') && listQuery[key] ? Number(listQuery[key]) : listQuery[key];
            const dataField = {
              data: this.dataComponent[item.name],
              name: item.name,
              event: item.event,
            };
            // if (item.event.length) {
              // eslint-disable-next-line no-await-in-loop
            await this.searchInput(dataField);
            // }
          }
        }
        if ((item.isShow === 1 || item.sendToBizfly === 1) && (item.name === 'nameCodeLeader' || item.name === 'departmentOfTheTicketCreator')) {
          if (item.linkApi !== null) {
            // eslint-disable-next-line no-await-in-loop
            await this.updateDataMapField(item, dataClone, false);
          }
        }
      }
      loader.hide();
    },
    checkTicketType(ticketGroup) {
      const filterData = this.listTicketGroup.filter((item) => item.groupTicketName === ticketGroup);
      if (filterData.length > 0 && filterData[0].typeTicketName != null) {
        return true;
      }
      return false;
    },
    changeTicketGroup(value) {
      this.typeTicketName = '';
      this.templateId = '';
      this.templateFields = [];
      this.dataComponent = _.cloneDeep(dataConstForm);
      this.listTicketGroup = _.cloneDeep(this.listTicketGroupClone);
      if (value) {
        const filterData = this.listTicketGroup.filter((item) => item.groupTicketName === value);
        if (filterData.length === 1 && filterData[0].typeTicketName == null) {
          this.templateFields = filterData[0].templateFields;
          this.templateId = filterData[0].id;
          this.checkTicketType();
          this.checkDataType();
        }
      }
    },
    changeTicketType(value) {
      this.templateId = '';
      this.templateFields = [];
      this.dataComponent = _.cloneDeep(dataConstForm);
      this.listTicketGroup = _.cloneDeep(this.listTicketGroupClone);
      if (value) {
        if (this.groupTicketName) {
          const filterData = this.listTicketGroup.filter((item) => item.groupTicketName === this.groupTicketName && item.typeTicketName === value);
          if (filterData.length) {
            this.templateFields = filterData[0].templateFields;
            this.templateId = filterData[0].id;
            this.checkTicketType();
            this.checkDataType();
          }
        }
      }
    },
    async getListTicketGroup() {
      const currentPath = this.$router.currentRoute.path;
      const trimmedPath = currentPath.replace(/^\/+/, '');
      const params = {
        'filters[$eq__screen]': trimmedPath,
        'filters[$eq__systemId]': 3,
        'filters[$eq__moduleId]': this.moduleId ? this.moduleId : '',
        limit: 9999,
      };
      const response = await TicketRepository.getListTicketApi(params);
      if (response.success) {
        this.listTicketGroup = response.data;
        this.listTicketGroupClone = response.data;
      }
    },
    async searchInput(component) {
      if (component.event.length === 0) {
        return;
      }
      const dataFilter = this.templateFields.filter((item) => component.event.includes(item.id));
      if (component.data) {
        const body = {};
        if (dataFilter.length > 0) {
          body[component.name] = component.data;
          if (component.data !== this.dataComponent[component.name]) {
            // eslint-disable-next-line no-restricted-syntax
            for (const item of dataFilter) {
              this.clearItem(item);
            }
          }
          const params = { ...this.dataComponent, ...body };
          const loader = this.$loading.show();
          // eslint-disable-next-line no-restricted-syntax
          for (const item of dataFilter) {
            // eslint-disable-next-line no-await-in-loop
            await this.processItem(item, params, component.change);
          }
          loader.hide();
        }
        // }
      } else if (dataFilter.length > 0) {
        // eslint-disable-next-line no-restricted-syntax
        for (const item of dataFilter) {
          this.clearItem(item);
        }
      }
    },
    clearItem(item) {
      this.dataComponent[item.name] = '';
      // eslint-disable-next-line no-param-reassign
      item.dataMapField = [];
      const dataFind = this.templateFields.filter((dataField) => item.event.includes(dataField.id));
      if (dataFind.length > 0) {
        // eslint-disable-next-line no-restricted-syntax
        for (const innerItem of dataFind) {
          this.clearItem(innerItem);
        }
      }
    },
    // eslint-disable-next-line consistent-return
    async updateDataMapField(item, body, isChange) {
      if ((item.linkApi !== null && this.dataComponent[item.name] === '') || isChange) {
        try {
          const response = await Repository.post(`${`${apiCrm}/${item.linkApi}`}`, body, { headers: TokenService.getHeader() });
          if (response.success) {
            // eslint-disable-next-line no-param-reassign
            item.dataMapField = response.data ? response.data : [];
          } else {
            // eslint-disable-next-line no-param-reassign
            item.dataMapField = [];
          }
          if (item.dataMapField.length === 0) {
            this.dataComponent[item.name] = '';
          }
          // eslint-disable-next-line no-param-reassign
          // item.isCallApi = true;
          return item;
        } catch (error) {
          console.log(error);
        }
      }
    },
    async processItem(item, params, isChange = false) {
      console.log(this.dataComponent, 'this.dataComponent');
      if ((this.dataComponent[item.name] === '' && item.dataMapField.length === 0) || isChange) {
        const dataUpdate = await this.updateDataMapField(item, params, isChange);
        if (dataUpdate && dataUpdate.dataMapField && dataUpdate.dataMapField.length === 1) {
          console.log(dataUpdate.name, dataUpdate.dataMapField[0].name, '414');
          this.dataComponent[dataUpdate.name] = dataUpdate.dataMapField[0].name;
          const dataFind = this.templateFields.filter((dataField) => dataUpdate.event.includes(dataField.id));
          console.log(dataFind, '111');
          if (dataFind.length > 0) {
            const innerBody = {};
            innerBody[dataUpdate.name] = this.dataComponent[dataUpdate.name];
            // eslint-disable-next-line no-shadow
            const params = { ...this.dataComponent, ...innerBody };
            // eslint-disable-next-line no-restricted-syntax
            for (const innerItem of dataFind) {
              // eslint-disable-next-line no-await-in-loop
              await this.processItem(innerItem, params);
            }
          }
        }
      }
    },
    async handleCreate() {
      const valid = await this.$refs.refComponent.validate();
      if (valid) {
        this.dialogConfirmSupport = true;
      }
    },
    async createForm() {
      const params = {
        templateId: this.templateId,
        ...this.dataComponent,
      };
      if (params.fileAttachment.length > 0) {
        const dataFilter = [];
        params.fileAttachment.forEach((item) => {
          if (item.name !== '') {
            dataFilter.push(item.name);
          }
        });
        params.fileAttachment = dataFilter;
      }
      try {
        const loading = this.$loading.show();
        const response = await TicketRepository.createTicketApi(params);
        loading.hide();
        if (response.success) {
          this.dialogConfirmSupport = false;
          this.$swal({
            type: 'success',
            icon: 'success',
            text: 'Gửi hỗ trợ khách hàng thành công',
          });
          await this.$router.push('/ticket');
        } else {
          this.$swal({
            type: 'error',
            icon: 'error',
            html: `<b>Có lỗi hệ thống<br><br>
                            Vui lòng tạo lại phiếu.</b>`,
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
<style lang="scss">
.master-form-ticket {
  input {
    font-size: 14px !important;
  }
}
</style>
